import styled from 'styled-components'

export const Container = styled.div`
  width: min(100%, 560px);
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 34px;
  border-radius: 32px;
  border: 1px solid rgba(182, 194, 214, 0.72);
  background: rgba(255, 255, 255, 0.84);
  box-shadow: 0 24px 70px rgba(25, 57, 78, 0.12);
  backdrop-filter: blur(16px);

  @media (max-width: 768px) {
    width: 100%;
    padding: 26px 20px;
    border-radius: 24px;
  }

  H2 {
    font-size: 1.5rem;

    font-weight: 700;
    color: #2d749c;
  }
`

export const LoginEyebrow = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 999px;
  background: #edf4fa;
  color: #2d749c;
  font-family: 'Public Sans', sans-serif;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
`

export const LoginTitle = styled.h1`
  margin: 18px 0 12px;
  color: #183449;
  font-family: 'Public Sans', sans-serif;
  font-size: clamp(2rem, 3vw, 3.1rem);
  font-weight: 800;
  line-height: 0.98;
  letter-spacing: -0.04em;
`

export const LoginDescription = styled.p`
  margin: 0 0 28px;
  color: #587084;
  font-family: 'Public Sans', sans-serif;
  font-size: 1rem;
  line-height: 1.7;
`

export const LoginTrustRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 22px;
`

export const LoginTrustItem = styled.div`
  padding: 10px 14px;
  border-radius: 16px;
  border: 1px solid #dbe5ef;
  background: #f8fbfe;
  color: #2a4d66;
  font-family: 'Public Sans', sans-serif;
  font-size: 13px;
  font-weight: 700;
`

export const LoginActionRow = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-top: 24px;

  @media (max-width: 640px) {
    flex-direction: column;
    justify-content: stretch;
  }
`

export const ErrorIcon = styled.img`
  width: 200px;
  height: 200px;
  margin-bottom: 30px;
`

export const ErrorContainer = styled.div`
  margin-top: 60px;
`
